export default __webpack_public_path__ + "static/career-hero-15df550b0f7247955ac42883746f937f.jpg";